<template>
  <section id="feedback">
    <div class="feedback-single" v-if="!viewFeedbackOverview && !feedbackSubmitted">
      <div class="feedback-single-header">
        <h2>Leave Feedback</h2>
        <small>{{ currentNode.name }}</small>
        <button class="btn-close" @click="closeFeedback()">
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="feedback-single-body">
        <div class="question-rate">
          <p>Rate How You Feel</p>
          <div class="radio-group">
            <div class="radio-item">
              <label for="q1-1">
                <img
                  class="emoticon"
                  :src="emoticon.veryUnhappy"
                  alt
                  :class="{ 'fade' : getActiveFeeling(1) }"
                />
                <input type="radio" id="q1-1" name="Very Unhappy" value="1" v-model="data.feeling" />
              </label>
            </div>
            <div class="radio-item">
              <label for="q1-2">
                <img
                  class="emoticon"
                  :src="emoticon.unhappy"
                  alt
                  :class="{ 'fade' : getActiveFeeling(2) }"
                />
                <input type="radio" id="q1-2" name="Unhappy" value="2" v-model="data.feeling" />
              </label>
            </div>
            <div class="radio-item">
              <label for="q1-3">
                <img
                  class="emoticon"
                  :src="emoticon.happy"
                  alt
                  :class="{ 'fade' : getActiveFeeling(3) }"
                />
                <input type="radio" id="q1-3" name="Happy" value="3" v-model="data.feeling" />
              </label>
            </div>
            <div class="radio-item">
              <label for="q1-4">
                <img
                  class="emoticon"
                  :src="emoticon.veryHappy"
                  alt
                  :class="{ 'fade' : getActiveFeeling(4) }"
                />
                <input type="radio" id="q1-4" name="Very Happy" value="4" v-model="data.feeling" />
              </label>
            </div>
          </div>
        </div>
        <div class="question-text">
          <p>Tell Us About It</p>
          <textarea placeholder="Enter Your Text Here" v-model="data.comment"></textarea>
        </div>
        <div class="buttons">
          <button
            class="btn btn-secondary"
            @click.prevent="addMoreFeedback()"
            :disabled="activateFeedbackButtons"
          >Add and continue</button>
          <button
            class="btn btn-primary"
            @click.prevent="submitFeedback()"
            :disabled="activateFeedbackButtons"
          >Submit Feedback</button>
        </div>
      </div>
    </div>
    <div class="feedback-overview" v-if="viewFeedbackOverview">
      <div class="feedback-single-header">
        <h2>Review Feedback</h2>
        <button class="btn-close" @click="closeFeedback()">
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="feedback-single-body">
        <div class="feedback-row" v-for="(review, index) in feedback" :key="index">
          <div class="row-1">
            <div class="img">
              <img
                v-if="review.feeling == 1"
                class="emoticon"
                :src="emoticon.veryUnhappy"
                alt="Very Unhappy"
              />
              <img
                v-if="review.feeling == 2"
                class="emoticon"
                :src="emoticon.unhappy"
                alt="Unhappy"
              />
              <img v-if="review.feeling == 3" class="emoticon" :src="emoticon.happy" alt="Happy" />
              <img
                v-if="review.feeling == 4"
                class="emoticon"
                :src="emoticon.veryHappy"
                alt="Very Happy"
              />
            </div>
            <div class="node">{{ review.nodeName }}</div>
          </div>
          <div class="row-2">{{ review.comment }}</div>
          <div class="row-3">
            <button
              class="btn btn-primary"
              @click.prevent="deleteFeedbackItem(review)"
            >Delete Feedback</button>
          </div>
        </div>
        <div class="feedback-userinfo">
          <p>Tell Us About It</p>
          <input placeholder="Your Name" type="text" v-model="overview.name" />
          <input placeholder="email@example.com" type="email" v-model="overview.email" />
        </div>
        <div class="buttons">
          <!-- <button class="btn btn-secondary" @click="cancelFeedback()">Cancel</button> -->
          <button
            class="btn btn-primary"
            @click="storeFeedbackToDB()"
            :disabled="activateSubmitAllButton"
          >Submit</button>
        </div>
      </div>
    </div>
    <div class="feedback-status" v-show="feedbackSubmitted">
      <button class="btn-close" @click="closeFeedback()">
        <i class="material-icons">close</i>
      </button>

      <div class="icon">
        <i class="material-icons">done</i>
      </div>
      <p>Your feedback has been submitted</p>
      <p>Please also consider completing our survey</p>
      <a
        class="btn"
        href="https://wh.snapsurveys.com/s.asp?k=157373714266"
        target="_blank"
      >Open survey</a>
    </div>
  </section>
</template>

<script>
import { store } from "../store";
import { mapState, mapGetters } from "vuex";

import VeryHappyEmoticon from "@/assets/images/VeryHappy.svg";
import VeryUnhappyEmoticon from "@/assets/images/VeryUnhappy.svg";
import HappyEmoticon from "@/assets/images/Happy.svg";
import UnhappyEmoticon from "@/assets/images/Unhappy.svg";

export default {
  name: "Feedback",
  props: {
    nodeData: Object,
    feedbackOverview: Boolean
  },
  data() {
    return {
      emoticon: {
        veryUnhappy: VeryUnhappyEmoticon,
        unhappy: UnhappyEmoticon,
        happy: HappyEmoticon,
        veryHappy: VeryHappyEmoticon
      },
      data: {
        feeling: 0,
        comment: ""
      },
      overview: {
        name: "",
        email: ""
      },
      subFeedback: false,
      feedbackSubmitted: false
    };
  },
  computed: {
    ...mapState(["feedback"]),
    currentNode() {
      return this.nodeData;
    },
    viewFeedbackOverview() {
      return this.feedbackOverview || this.subFeedback;
    },
    activateFeedbackButtons() {
      return this.data.feeling == 0 || this.data.comment == "";
    },
    activateSubmitAllButton() {
      return this.overview.name == "" || !this.validEmail(this.overview.email);
    }
  },
  mounted() {},
  methods: {
    getActiveFeeling(feelingVal) {
      if (this.data.feeling == 0) {
        return false;
      } else if (feelingVal != this.data.feeling) {
        return true;
      } else {
        return false;
      }
    },
    deleteFeedbackItem(review) {
      var index = this.feedback.indexOf(review);
      if (index > -1) {
        this.feedback.splice(index, 1);
      }
      // Delete last feedback item resets the entire modal.
      if (this.feedback.length == 0) {
        this.overview.name = "";
        this.overview.email = "";
        this.closeFeedback();
      }
    },
    addReviewToStore() {
      let nodeName = this.currentNode.name;
      let feeling = this.data.feeling;
      let comment = this.data.comment;

      this.$store.commit("addFeedback", {
        nodeName: nodeName,
        feeling: feeling,
        comment: comment
      });
    },
    addMoreFeedback(event) {
      this.addReviewToStore();
      this.$root.$emit("updateFeedbackVis", false, false);
    },
    submitFeedback() {
      this.addReviewToStore();
      this.subFeedback = true;
    },
    async storeFeedbackToDB() {
      const user = this.overview;

      let userFeedback = {
        email: user.email,
        generalComment: "",
        name: user.name
      };

      await this.$store.dispatch("submitFeedback", userFeedback);

      if (this.feedback.length == 0) {
        this.feedbackOverview = false;
        this.feedbackSubmitted = true;
        this.subFeedback = false;
        // setTimeout(() => {
        //     this.feedbackSubmitted=false
        //     this.closeFeedback();
        // }, 2000);

        setTimeout(() => {
          //console.log("going home");
          this.$router.push("/");
        }, 10000);
      }
    },
    finshFeedback() {
      this.closeFeedback();
    },
    closeFeedback() {
      this.$root.$emit("updateFeedbackVis", false, false);
      //this.$router.push("/");

      //this.viewFeedbackOverview = false;
    },
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }
};
</script>


